__turbopack_context__.v({
  "actionGroup": "RemindMe-module-scss-module__519Ila__actionGroup",
  "buttonRow": "RemindMe-module-scss-module__519Ila__buttonRow",
  "consentLabel": "RemindMe-module-scss-module__519Ila__consentLabel",
  "consentRow": "RemindMe-module-scss-module__519Ila__consentRow",
  "organizerInfoSection": "RemindMe-module-scss-module__519Ila__organizerInfoSection",
  "remindMeIcon": "RemindMe-module-scss-module__519Ila__remindMeIcon",
  "remindMeModalContent": "RemindMe-module-scss-module__519Ila__remindMeModalContent",
  "reminderSetButtonVariant": "RemindMe-module-scss-module__519Ila__reminderSetButtonVariant",
  "reminderSetDescription": "RemindMe-module-scss-module__519Ila__reminderSetDescription",
  "reminderSetTitle": "RemindMe-module-scss-module__519Ila__reminderSetTitle",
});
